/* eslint-disable @typescript-eslint/ban-ts-comment */
import { LocalFind, LocalInsert } from '@weblite/persist'
// @ts-ignore
import {
  GetChangelogs,
  reqGetChangelogs,
  Changelog,
} from '@weblite/ts-action/admin'
import { Timestamp } from '@weblite/ts-action/types'
import { twaVersion } from '$func/environmentInfo'
import { request } from '$setup/ws'
import { showChangelogModal } from '$comp/modals/changelog'
import { showUpdateTwaAvailableDialog } from '$comp/modals/permission-dialog'
import { weekInMilliSeconds } from '$func/time'
import { getCurrentRelease } from './storage'
import { VERSION } from '$setup/version'
import { TWA_API_SUPPORT } from '$logic/twaCommunication'
import { dateWithOffset } from '$setup/time-offset'

// @ts-ignore
export const TWA_VERSION = import.meta.env.VITE_TWA_VERSION

export function needUpdateTWA() {
  return twaVersion && twaVersion < TWA_VERSION
}

// @ts-ignore
const downloadTwaSrc = import.meta.env.VITE_TWA_DOWNLOAD_SRC

export const needForceUpdateTwa = () => {
  return (
    twaVersion && downloadTwaSrc && +twaVersion < TWA_API_SUPPORT.LEAST_VERSION
  )
}

export function checkUpdateTWA() {
  if (needUpdateTWA()) showUpdateTwaAvailableDialog()
}

function shouldIgnoreForcePromotion() {
  const { time, version } = LocalFind('ignoreInstallPromotion') || {}
  if (!time) return false

  return !(
    time + weekInMilliSeconds < dateWithOffset() || version !== TWA_VERSION
  )
}

export function ignoreInstallPromotion() {
  LocalInsert('ignoreInstallPromotion', {
    time: dateWithOffset(),
    version: TWA_VERSION,
  })
}

async function getAppReleasesAfter(date: Timestamp) {
  const res = await request<GetChangelogs>(
    reqGetChangelogs({
      ...(date && { after: date }),
      before: dateWithOffset(),
    }),
    { retry: -1 },
  )
  if (res.error) {
    console.error(res.error.message)
    return []
  }
  return res.payload.changelogs.map(({ date: isoDate, ...other }) => {
    return { ...other, date: new Date(isoDate) }
  })
}

let cachedNewReleases: Changelog[] = null
export async function getAppNewReleases() {
  if (cachedNewReleases) return cachedNewReleases
  const { releaseTime } = getCurrentRelease()
  const res = await getAppReleasesAfter(releaseTime)
  // @ts-ignore
  cachedNewReleases = res
  return res
}

export async function checkNewAppVersionInstalled() {
  if (VERSION === getCurrentRelease()?.version) return
  const releaseVersions = await getAppNewReleases()
  if (!releaseVersions?.length) return
  showChangelogModal()
}
